<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->
<div class="row">
  <div class="col px-0">


  <div class="mb-0 header-bg">
  <div class="spacer"></div>
    <div class="row">
      <div class="col-md-11 mx-auto">
        <div class="row">
          <div class="col-5">
            <h1 class="f-36 font-weight-600 mb-3 w-500">
              Reach out to prospect from your target company
            </h1>
            <h2 class="f-18 font-weight-500 line-height-1 mb-4">Search through our company directory to access employee contacts and salary insights.</h2>
            <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
              <a data-testid="auto-companydirectory-a-1" class="nav-link active mb-3" id="v-pills-employeecontact-tab" data-bs-toggle="pill" href="#v-pills-employeecontact" role="tab" aria-controls="v-pills-employeecontact" aria-selected="true"> <span class="circle-btn mr-3"><i class="far fa-angle-right"></i></span> Get employee contact information</a>
              <a data-testid="auto-companydirectory-a-2" class="nav-link mb-3" id="v-pills-emloyeesalary-tab" data-bs-toggle="pill" href="#v-pills-emloyeesalary" role="tab" aria-controls="v-pills-emloyeesalary" aria-selected="false">
                <span class="circle-btn mr-3"><i class="far fa-angle-right"></i></span>Get employee salary insights</a>
              <a data-testid="auto-companydirectory-a-3" class="nav-link mb-3" id="v-pills-genderdiversity-tab" data-bs-toggle="pill" href="#v-pills-genderdiversity" role="tab" aria-controls="v-pills-genderdiversity" aria-selected="false">
                <span class="circle-btn mr-3"><i class="far fa-angle-right"></i></span>Get info on Gender Diversity</a>
            </div>
          </div>
          <div class="col-7">
            <div class="tab-content" id="v-pills-tabContent">
              <div class="tab-pane fade show active text-center" id="v-pills-employeecontact" role="tabpanel" aria-labelledby="v-pills-employeecontact-tab">
                <img src="../../../../assets/images/group-7.png" class="img-fluid" alt=" Get employee contact information" srcset="">

              </div>
              <div class="tab-pane fade text-center" id="v-pills-emloyeesalary" role="tabpanel" aria-labelledby="v-pills-emloyeesalary-tab">
                <img src="../../../../assets/images/group-4.png" class="img-fluid" alt="Get employee salary insights" srcset="">
              </div>
              <div class="tab-pane fade text-center" id="v-pills-function" role="tabpanel" aria-labelledby="v-pills-function-tab">
                <img src="../../../../assets/images/group-8.png" class="img-fluid" alt="Understand Functions & Job Titles" srcset="">

                </div>
              <div class="tab-pane fade text-center" id="v-pills-genderdiversity" role="tabpanel" aria-labelledby="v-pills-genderdiversity-tab">
                <img src="../../../../assets/images/group-14.png" class="img-fluid" alt="Get info on Gender Diversity" srcset="">

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="companydirectory-search wccard py-3 bt-0">
    <div>

      <div class="companydirectory-search">
        <h2 class="text-center font-weight-bold f-20 mb-2">Company Directory</h2>

        <input data-testid="auto-companydirectory-input-1" type="text" placeholder="Type and search for company or industry names" [(ngModel)]="searchName"
          (input)="onKeyPress(searchName)" [matAutocomplete]="employee_auto">
        <mat-autocomplete #employee_auto="matAutocomplete">
          <mat-option *ngFor="let name of searchList" [value]="name?.name"
            (onSelectionChange)="searchRedirect(name?.name,name?.type,name?.id)">
            <span style="display: flex; justify-content: space-between;">

              <span>
                <span class="companydirectory-search-img text-9696" *ngIf="name?.type == 'company' && name?.companylogo==null">
                  <i class="fas fa-building"></i>
                </span>
                <img class="companydirectory-search-img" *ngIf="name?.type == 'company' && name?.companylogo!=null" [src]="name?.companylogo" />
                {{name.name}} <span *ngIf="name?.type == 'company'"> - {{ name?.industry }}</span>
              </span>
              <span>{{name.type}}</span>
            </span>
          </mat-option>
        </mat-autocomplete>
  </div>
  <div class="companydirectory px-6">
    <hr/>
    <div class="row" *ngFor="let cluster of industryList">
      <div class="col-md-3 mb-3" *ngFor="let industry of cluster">
        <a data-testid="auto-companydirectory-a-4" (click)="searchRedirect(industry?.industryname,'industry',industry?.industryid)">{{ industry.industryname }}</a>

          </div>
        </div>

      </div>
    </div>
    <hr/>
    <div class="companydirectory-pagination mt-5">
      <nav aria-label="Page navigation example mx-auto">
        <ul class="pagination justify-content-center">
          <li class="page-item" (click)="pagination('prev')">
            <a data-testid="auto-companydirectory-a-5" class="page-link" aria-label="Previous" [class.disabled-btn] = "activePage+1 == 1" >
              <<
            </a>
          </li>
          <li *ngFor="let num of paginationArray"
              class="page-item"
              [class.active] = 'activePage+1 == num'
              (click)="pagination('page',num-1)">
            <a data-testid="auto-companydirectory-a-6" class="page-link"> {{ num }} </a>
          </li>
          <li class="page-item" (click)="pagination('next')">
            <a data-testid="auto-companydirectory-a-7" class="page-link" aria-label="Next" [class.disabled-btn] = "activePage+1 == lastPageNumber">
              >>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>
</div>
